/* TurboDucha 3X · JS mínimo (galería, selector de planes, botón fijo y enlace con Releasit COD) */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function init() {
    initGallery();
    initPlans();
    initBuy();
    initReviews();
    initSticky();
  }

  /* Galería: miniaturas que desplazan el carrusel y se marcan al deslizar */
  function initGallery() {
    var gal = $('[data-tdx-gal]');
    var thumbs = $$('[data-tdx-thumb]');
    if (!gal || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = Number(btn.getAttribute('data-tdx-thumb'));
        gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' });
      });
    });

    var ticking = false;
    gal.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      });
    }, { passive: true });
  }

  /* Selector de planes: sincroniza el <select name="id"> (lo que lee Releasit) y los precios en pantalla */
  function initPlans() {
    var select = $('#tdx-variant');
    var radios = $$('[data-tdx-plan]');
    if (!select || !radios.length) return;

    function apply(radio, fromUser) {
      radios.forEach(function (r) { r.closest('.tdx-plan').classList.toggle('is-selected', r === radio); });
      select.value = radio.value;
      /* Releasit (y cualquier otro script) lee la variante de los campos name="id" o de ?variant= */
      $$('input[name="id"], select[name="id"]').forEach(function (f) {
        if (f !== select) f.value = radio.value;
      });
      if (fromUser) select.dispatchEvent(new Event('change', { bubbles: true }));
      /* Releasit toma la variante del parámetro ?variant= de la URL: se actualiza siempre (también con el plan inicial) */
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== radio.value) {
          url.searchParams.set('variant', radio.value);
          window.history.replaceState(null, '', url.toString());
        }
      } catch (e) { /* sin historial: se ignora */ }

      var price = radio.getAttribute('data-price');
      var compare = radio.getAttribute('data-compare');
      var off = radio.getAttribute('data-off');

      $$('[data-tdx-price]').forEach(function (el) { el.textContent = price; });
      $$('[data-tdx-total]').forEach(function (el) { el.textContent = price; });
      $$('[data-tdx-sel-price]').forEach(function (el) { el.textContent = price; });
      $$('[data-tdx-sel-units]').forEach(function (el) { el.textContent = radio.getAttribute('data-units'); });

      var cEl = $('[data-tdx-compare]');
      if (cEl) { cEl.textContent = compare; cEl.hidden = !compare; }
      var oEl = $('[data-tdx-off]');
      if (oEl) { oEl.textContent = off ? '-' + off + '%' : ''; oEl.hidden = !off; }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r, true); });
    });
    var checked = radios.filter(function (r) { return r.checked; })[0];
    if (checked) apply(checked, false);
  }

  /* Opiniones: muestra las ocultas al tocar "Ver las N opiniones" */
  function initReviews() {
    $$('[data-tdx-reviews-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sec = btn.closest('.tdx-reviews');
        $$('[data-tdx-review-extra]', sec).forEach(function (r) { r.hidden = false; });
        btn.remove();
      });
    });
  }

  /* Botón principal: SIEMPRE abre el formulario de Releasit COD; nunca añade al carrito.
     Si el botón de Releasit aún no está listo, espera unos segundos y reintenta. */
  function initBuy() {
    var buy = $('#tdx-buy');
    var form = $('#tdx-form');
    if (!buy || !form) return;

    /* Solo el botón real de Releasit. [data-rsi-cod-button] es un envío nativo al carrito: NO se usa. */
    var TRIGGERS = '#rsi_buy_now_button, button.rsi_animation_shake';
    var busy = false;

    /* Primero el botón de nuestra sección tdx-releasit. Nunca el del carrito lateral: ese botón hace que Releasit
       vacíe el carrito y arme el pedido con lo que haya ahí (variante vacía y total $0). */
    function findTrigger() {
      var own = $$('[data-tdx-releasit] #rsi_buy_now_button, [data-tdx-releasit] button.rsi_animation_shake');
      var nodes = own.concat($$(TRIGGERS));
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n === buy || n.disabled) continue;
        if (n.closest('cart-drawer, cart-drawer-component, cart-notification, .cart-drawer, .drawer')) continue;
        return n;
      }
      return null;
    }

    function setLoading(on) {
      busy = on;
      buy.setAttribute('aria-busy', on ? 'true' : 'false');
      buy.classList.toggle('is-loading', on);
    }

    function showError() {
      var box = $('[data-tdx-buy-error]');
      if (box) box.hidden = false;
    }

    function openReleasit() {
      if (busy) return;
      var box = $('[data-tdx-buy-error]');
      if (box) box.hidden = true;

      var trigger = findTrigger();
      if (trigger) { trigger.click(); return; }

      /* Releasit todavía no inyectó su botón: reintentar hasta 6 s */
      setLoading(true);
      var tries = 0;
      var timer = setInterval(function () {
        var t = findTrigger();
        tries++;
        if (t) { clearInterval(timer); setLoading(false); t.click(); }
        else if (tries >= 24) { clearInterval(timer); setLoading(false); showError(); }
      }, 250);
    }

    /* Bloquea cualquier envío nativo (clic, Enter): el formulario de Releasit es el único camino de compra */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      openReleasit();
    });
    buy.addEventListener('click', function (event) {
      event.preventDefault();
      openReleasit();
    });

    /* Los demás botones (fijo móvil, cierre) lanzan exactamente el mismo flujo */
    $$('[data-tdx-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openReleasit();
      });
    });
  }

  /* Botón fijo móvil: aparece cuando el botón principal ya quedó arriba de la pantalla */
  function initSticky() {
    var sticky = $('[data-tdx-sticky]');
    var cta = $('[data-tdx-cta]');
    if (!sticky || !cta || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.hidden = !show;
      document.body.classList.toggle('tdx-has-sticky', show);
    });
    io.observe(cta);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
